export default __webpack_public_path__ + "static/media/blue_mark_icon.ae283786.svg";